import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalText, ModalType } from '../../services/modal.service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @Input() modalType: ModalType;
  @Input() text: ModalText;

  bodyTitle: string;
  bodyText?: string;
  modalTitle?: string;

  constructor(private activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.modalTitle = this.text.modalTitle;
    this.bodyTitle = this.text.bodyTitle;
    this.bodyText = this.text.bodyText;
  }

  save() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.dismiss();
  }
}
